import Route from '@ember/routing/route';
import type { AppServicesWaldenConnectModel } from 'walden-fast/routes/app/services/walden-connect';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class AppServicesWaldenConnectIndexRoute extends Route {
  @service('router') declare routerService: RouterService;

  afterModel() {
    const parentModel = this.modelFor(
      'app.services.walden-connect',
    ) as AppServicesWaldenConnectModel;

    const companies = parentModel.availableClientNameLocals ?? [];
    const firstCompany = companies.find((company) =>
      company.externalIdentifiers?.powerBI?.clientNameLocal?.trim(),
    );

    if (firstCompany) {
      const clientNameLocal =
        firstCompany.externalIdentifiers!.powerBI!.clientNameLocal;
      this.routerService.replaceWith(
        'app.services.walden-connect.client',
        clientNameLocal,
      );
    }
  }
}
